<script>
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()
    
    export let data
    
    $: disabled = data.sheet.cells.length === 0
    $: buffer = columnsToFields(data.sheet.cells)

    let selected = []
    let importAll = false

    $: updateAll(importAll)
    //$: console.log(JSON.stringify(selected))

    function updateAll(importAll) {
        buffer.forEach(item => {
            updateItem(item, 'selected')({ target: { checked: importAll } })
        })
    }

    function columnsToFields(columns) {
        return columns.map((name, index) => {
            return {
                idx        : index,
                definition : name,
                name       : null,
                key        : false,
                selected   : false
            }
        })
    }

    function updateItem(item, property) {
        return e => {
                const value = "key" === property || "selected" === property ? e.target.checked : e.target.value
                const copy = Object.defineProperty(item, property, {
                    value,
                    writable: true,
                    enumerable: true,
                })

            selected = selected.filter(i => i.idx !== item.idx)
            if(item.selected) {
                selected = [...selected, item]
            }
        }
    }

    function isSelected(selected, item) {
        return selected.find(i => i.idx === item.idx)
    }

    function iconGiven(selected, item) {
        if(isSelected(selected, item)) 
            return 'green check'
         else 
            return 'ban inverted grey'
    }

    function stepDone() {
        dispatch('done', selected)
    }
</script>

<div class="ui basic segment" class:disabled>
    <div class="ui basic segment">
        <h3 class="ui header">{data.sheet.title || ''}</h3>
    </div>
    <div class="ui right aligned basic segment">
        <div class="ui toggle checkbox">
            <input type="checkbox" bind:checked={importAll}>
            <label>Importar Todos</label>
        </div>
    </div>
    <div class="ui right aligned basic segment">
        <button class="ui blue button" 
                class:disabled={disabled || selected.length === 0}
                on:click|preventDefault={stepDone}>Importar {selected.length} campos</button>
    </div>
    <form class="ui big form">
        <table class="ui celled padded table">
            <thead>
                <tr>
                    <th class="single line">Coluna</th>
                    <th>Nome</th>
                    <th>Chave</th>
                    <th>Importar</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {#each buffer as item (item.idx)}
                    <tr>
                        <td>
                            <h4 class="ui header">{item.definition}</h4>
                        </td>
                        <td>
                            <div class="field">
                                <input  on:change={updateItem(item, 'name')}
                                        type="text"
                                        autocomplete="false">
                            </div>                        
                        </td>
                        <td>
                            <div class="ui toggle checkbox">
                                <input type="checkbox" on:change={updateItem(item, 'key')}>
                                <label></label>
                            </div>
                        </td>
                        <td>
                            <div class="ui toggle checkbox">
                                <input type="checkbox" checked={isSelected(selected, item)} on:change={updateItem(item, 'selected')}>
                                <label></label>
                            </div>
                        </td>
                        <td>
                            <i class="{iconGiven(selected, item)} icon"></i>
                        </td>
                    </tr>                
                {/each}
            </tbody>
        </table>
    </form>
</div>